import Client from './client';

export default class ShopifyWebhookEvents extends Client {
  constructor(opts) {
    let options = opts;

    if (typeof opts === 'string') {
      options = { host: opts }; // convert host string to options object
    }

    options.serviceName = 'API Internal';

    super(options);
  }

  postShopsByShopifyShopIdAndTopicAndAction(shopifyShopId, topic, action, options = {}) {
    return this.makeRequest(`${this.host}/shopify/webhook/events/shops/${shopifyShopId}/${topic}/${action}`, {
      ...options,
       method: 'POST',
    });
  }

  postByTopicAndAction(topic, action, options = {}) {
    return this.makeRequest(`${this.host}/shopify/webhook/events/${topic}/${action}`, {
      ...options,
       method: 'POST',
    });
  }

}
